import { call } from '@apparel/core/utils/functions/call';
import { useLoading } from '@apparel/react/hooks';
import Button, { ButtonProps } from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import React, { useCallback } from 'react';
import { CartService } from './CartService';

export interface CartResetProps extends Omit<ButtonProps, 'onReset'> {
    onReset?: (before: boolean) => void;
}

export const CartReset = React.memo(({ onClick, onReset, ...rest }: CartResetProps) => {
    const [state, { start, stop }] = useLoading();
    rest.children = rest.children || 'Clear Cart';

    const handleClear = useCallback(async () => {
        call(onReset, true);
        start();
        await CartService.getInstance().clear();
        stop();
    }, [onClick, start, stop]);

    return (
        <Button
            {...rest}
            onClick={handleClear}
            endIcon={state ? <CircularProgress size={16} thickness={2} color={'inherit'} /> : null}
        />
    );
});

export default CartReset;
